import { stringify } from 'qs'
import CryptoJS from 'crypto-js'
import { LANGUAGE_TYPE_OPTIONS } from '@/packages/plugins/hook/useLanguage'
import { UA_PROTOCOLS, resolveUaLanguageKey, isUnityUA } from '@/packages/plugins/appUAConfig'
/**
 * 生成uuid方法
 * @returns {string}
 */
export const createUUID = function (tag) {
  var d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now() //use high-precision timer if available
  }
  var uuid = 'xxxxxxxx-xxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
  if (tag) {
    uuid = tag + '_' + uuid
  }
  return uuid
}

export const isObject = (value) => {
  return value !== null && typeof value === 'object'
}

/**
 * 获取列表组件uuid
 * @param {*} str
 * @returns
 */
export const getListComponentUUID = (str) => {
  const underscoreIndex = str.indexOf('_')
  const start = str.substring(0, underscoreIndex)
  const end = str.substring(underscoreIndex + 1, underscoreIndex + 14)
  return `${start}_${end}`
}

/**
 * 参数签名(object)
 *
 * @param data data
 * @param secretKey secretKey
 */
export function getSignedData(data, secretKey) {
  const keys = Object.keys(data).sort()
  let sign = ''
  const sortData = {}
  keys.forEach((key) => {
    let value = data[key]
    if (value === 'object') {
      value = ''
    }
    if (Array.isArray(value)) {
      value = ''
    }
    if (!(value === undefined || value === null || value === '')) {
      // 去除数收尾空格
      if (typeof value === 'string') sortData[key] = value.trim()
      else sortData[key] = value
    }
  })
  let source = stringify(sortData, {
    encode: false
  })
  source = source + '&' + secretKey
  sign = CryptoJS.MD5(source).toString().toLowerCase()
  console.log(`签名参数: ${source}, 签名结果:${sign}`)
  return sign
}

/**
 * 参数签名(string)
 *
 * @param  data data
 * @param secretKey secretKey
 */
export function getSignedDataStr(data, secretKey) {
  let source = stringify(data)
  const signSource = source + secretKey
  source += 'sign=' + CryptoJS.MD5(signSource).toString().toLowerCase()
  // console.log(`参数：${source}`);
  return source
}
/**
 * 获取时间戳（秒）
 */
export function getTimestamp() {
  return new Date().valueOf()
}

/**
 * 获取随机数(0-10000]
 */
export function getRandom() {
  return (Math.random() * 1000000) << 0
}

/**
 * 获取指定位数随机数
 *
 * @param len 随机数长度
 */
export function randomNum(len) {
  let salt = ''
  for (let i = 0; i < len; i++) {
    let tmp = String(Math.floor(Math.random() * 10))
    if (!tmp) {
      tmp = '2'
    }
    salt += tmp
  }
  return salt
}

/**
 * 生成指定长度的随机字符串
 * @param length 随机字符串的长度
 * @returns 生成的随机字符串
 */
export function generateRandomString(length) {
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

/**
 * 动态计算适配px
 * @param {*} number
 * @returns
 */
export function computeRatioPx(number) {
  if (import.meta.env.VITE_APP_TAG !== 'H5') {
    number = `${number}px`
  } else {
    const contentWeight = window.innerWidth || 750
    const ratio = contentWeight / 750
    number = Math.round(Number(number) * ratio) + 'px'
  }
  return number
}

export function computeRatio(number) {
  if (import.meta.env.VITE_APP_TAG === 'H5') {
    const contentWeight = window.innerWidth || 750
    const ratio = contentWeight / 750
    number = Math.round(Number(number) * ratio)
  }
  return number
}

export function delay(seconds) {
  return new Promise((resolve) => {
    setTimeout(resolve, seconds)
  })
}

/** 获取当前语言标识, 兼容ios UA_LANGUAGE/{language}（language key 按协议解析：weelife-language / WBBridge-language） */
export const getLocaleLanguage = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  const languageKey = resolveUaLanguageKey(userAgent)?.toLowerCase()
  if (languageKey) {
    const language = userAgent.match(new RegExp(`(${languageKey})/([\\S.]+)`))
    if (language && language.length > 0) {
      const languageValue = language[language.length - 1]
      // 捕获段可能吞入后续 data 段，按任一协议 data key 截断
      const dataKey = UA_PROTOCOLS.map((protocol) => protocol.data.toLowerCase()).find((key) => languageValue.includes(key))
      if (dataKey) {
        const index = languageValue.indexOf(dataKey)
        return index !== -1 ? languageValue.substring(0, index) : 'en'
      } else {
        return languageValue
      }
    } else {
      return 'en'
    }
  } else if (isUnityUA(userAgent)) {
    const language = userAgent.match(/language:([^,]+)/)
    if (language && language.length > 0) {
      return language[language.length - 1]
    } else {
      return navigator.language.toLowerCase()
    }
  }
  return navigator.language.toLowerCase()
}

export const getLanguage = (type) => {
  let lgTag = 'en'
  const language = getLocaleLanguage()
  for (const item of LANGUAGE_TYPE_OPTIONS) {
    const lgKeys = item.browserCodes.split(',')
    if (lgKeys.includes(language)) {
      lgTag = item.value
      break
    }
  }
  // 特殊处理, 编辑器的中文配置
  if (lgTag === 'zh') {
    return type === 'api' ? 'zh-Hans' : 'zh'
  } else {
    return lgTag
  }
}

/**
 * 判断path是否为外链
 * @param {string} path
 * @returns {Boolean}
 */
export const isExternal = (path) => /^(https?:|mailto:|tel:|blob:)/.test(path)

/** 分割数组 */
export const sliceArray = (arr, size) => {
  const tempArr = []
  for (let i = 0; i < arr.length; i = i + size) {
    tempArr.push(arr.slice(i, i + size))
  }
  return tempArr
}

/**
 * 切割文件名
 * @param {*} path
 * @returns
 */
export const splitFileName = (path) => {
  let fileArr = []
  let fileName = ''
  let suffix = ''
  // 判断是否为外链接地址，或者全路径地址
  // 是则提取文件名+后缀
  if (isExternal(path) || path.split('/').length > 1) {
    const tempArr = path.split('/')
    fileName = tempArr[tempArr.length - 1]
  } else {
    fileName = path
  }
  fileArr = fileName.split('.')
  if (fileArr.length === 3) {
    suffix = fileArr[fileArr.length - 2] + '.' + fileArr[fileArr.length - 1]
  } else {
    suffix = fileArr[fileArr.length - 1]
  }
  const prefix = fileName.split('.' + suffix)[0]
  // console.log('suffix && prefix', suffix, prefix)
  return {
    prefix,
    suffix
  }
}

/**
 * 切割文件名版本-V2
 * 为兼容非资源文件命名
 * @param path
 * @returns
 */
export const splitFileNameV2 = (path) => {
  let fileArr = []
  let fileName = ''
  let suffix = ''
  // 判断是否为外链接地址，或者全路径地址
  // 是则提取文件名+后缀
  if (isExternal(path) || path.split('/').length > 1) {
    const tempArr = path.split('/')
    fileName = tempArr[tempArr.length - 1]
  } else {
    fileName = path
  }
  fileArr = fileName.split('.')
  if (fileArr.length >= 3) {
    const validSuffixArr = ['mp3', 'wav', 'ogg', 'aac', 'wma', 'flac', 'm4a', 'ac3', 'amr', 'mp4', 'mov', 'avi', 'wmv', 'flv', 'mkv', 'mpg', 'mpeg', 'lrc', 'unity3d', 'txt', 'json']
    if (validSuffixArr.includes(fileArr[fileArr.length - 2])) {
      suffix = fileArr[fileArr.length - 2] + '.' + fileArr[fileArr.length - 1]
    } else {
      suffix = fileArr[fileArr.length - 1]
    }
  } else {
    suffix = fileArr[fileArr.length - 1]
  }
  const prefix = fileName.split('.' + suffix)[0]
  // console.log('suffix && prefix', suffix, prefix)
  return {
    prefix,
    suffix
  }
}

/**
 * 获取当前 URL 的查询参数并以对象形式返回。
 * 如果传入了外部 URL，将从外部 URL 获取参数。
 * @param externalUrl - 可选的外部 URL
 * @returns 一个包含 URL 参数的对象
 */
export const urlParam2Obj = (externalUrl) => {
  let url

  try {
    // 如果传入了外部 URL，尝试解析它
    if (externalUrl) {
      url = new URL(externalUrl)
    } else {
      // 否则使用当前窗口的 URL
      url = new URL(window.location.href)
    }
  } catch (error) {
    console.error('Invalid URL provided:', externalUrl)
    return {}
  }

  const params = new URLSearchParams(url.search)
  const paramObject = {}

  // 遍历所有的 URL 参数
  params.forEach((value, key) => {
    paramObject[key] = value
  })

  return paramObject
}
